const NUMBER_FIXED_POINT = 2;
const LOAD_THRESHOLD = 200;
const TIME_INTERVAL_MINUTES = 5;

/*
  1000 watts for 1 hour = 1 kWh If you take 12 readings at 1000W (every 5 min): 
  12 × 1000 = 12000 total watts 12000 ÷ 12000 = 1 kWh 
*/


const trailerUsage = (trailerData) => {
  console.log(trailerData);

  //Total number of hours report in the data provided
  // determine this because sometimes not all 24 hours is accounted for
  const reportedHours = Number(
    ((Object.keys(trailerData).length * TIME_INTERVAL_MINUTES) / 60)
    // .toFixed(
    //   NUMBER_FIXED_POINT
    // )
  );
  console.log("total accum time of data in hours: ");
  console.log(reportedHours);
  console.log("==================================");

  const hoursOnGrid = Number(
    (Object.values(trailerData).filter((d) => d?.Grid > 0).length *
      TIME_INTERVAL_MINUTES) /
      60
    //.toFixed(NUMBER_FIXED_POINT)
  );
  console.log('total accum time within threshold on "grid" in hours: ');
  console.log(hoursOnGrid);
  console.log("==================================");

  //total hours on offGrid (within threshold)
  const hoursOffGrid = Number(reportedHours - hoursOnGrid);
  // const hoursOffGrid = Number(
  //   (hoursWithinthreshold - hoursOnGrid).toFixed(NUMBER_FIXED_POINT)
  // );
  console.log("derived time on offGrid/battery in hours: ");
  console.log(hoursOffGrid);
  console.log("==================================");

  //percentage of hours that are on offGrid
  const percentHoursOffGrid = Math.round((hoursOffGrid / reportedHours) * 100);
  console.log("percent time on offGrid & battery: ");
  console.log(percentHoursOffGrid);
  console.log("==================================");

  //Aggregate totals of all datasets (for referenc, not relevant for calculations)
  //
  const aggregatedAll = {};
  for (let time in trailerData) {
    for (let label in trailerData[time]) {
      if (!aggregatedAll[label]) {
        aggregatedAll[label] = 0.0;
      }
      aggregatedAll[label] += parseFloat(trailerData[time][label]);
    }
  }
  console.log("Aggregated totals by label (original data)");
  console.log(aggregatedAll);
  console.log("==================================");


  //Determine total wattage of offGrid and grid values
  const totalWatt =
    parseFloat(aggregatedAll.PV) +
    parseFloat(aggregatedAll.Grid);
  console.log("Total Watt");
  console.log(totalWatt);
  console.log("==================================");

  //Convert total watts to kwh using total hours reported within the set threshold
  const totalkWh = wattTokWh(totalWatt, reportedHours);
  console.log("Total kWh");
  console.log(totalkWh);
  console.log("==================================");

  //Convert offGrid watts to kwh using total hours reported within the set threshold
  const offGridkWh = wattTokWh(aggregatedAll.PV, hoursOffGrid);
  console.log("Off Grid kWh");
  console.log(offGridkWh);
  console.log("==================================");

  //Convert grid watts to kwh using total hours reported within the set threshold
  const gridkWh = Number((totalkWh - offGridkWh));
  // const gridkWh = Number((totalkWh - offGridkWh).toFixed(NUMBER_FIXED_POINT));
  console.log("Grid kWh");
  console.log(gridkWh);
  console.log("==================================");

  //determine the percentage of offGrid kwh
  const percentOffGrid = Number(
    ((offGridkWh / totalkWh) * 100)
    // .toFixed(NUMBER_FIXED_POINT)
  );
  // const percentOffGrid = Math.round((offGridkWh / totalkWh) * 100);
  console.log("Percent power from offGrid");
  console.log(percentOffGrid);
  console.log("==================================");

  //return all values
  return {
    reportedHours,
    hoursOnGrid,
    hoursOffGrid,
    percentHoursOffGrid,
    // aggregatedAll,
    totalWatt,
    totalkWh,
    offGridkWh,
    gridkWh,
    percentOffGrid,
  };
};

const wattTokWh = (watts) => {
  /*

    Since data comes in 5-minute intervals, convert each reading individually:
    kWhForEachReading = watts / 12000
    Why 12000? Because (5 min / 60 min) / 1000 = 1/12000

  */
  const adjusted = (TIME_INTERVAL_MINUTES / 60) / 1000
  const w = Number(watts) || 0;
  // const h = Number(hours) || 0;
  return w * adjusted;
  // return w / 12000;
};

export {
  NUMBER_FIXED_POINT,
  LOAD_THRESHOLD,
  TIME_INTERVAL_MINUTES,
  trailerUsage,
  wattTokWh,
};
